var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensorNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Disconnect",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.89,
    height: 27.811,
    viewBox: "0 0 23.89 27.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Disconnect .cls-1 {\n        fill: #c3c3c3;\n      }\n\n      #Disconnect .cls-2 {\n        fill: #151517;\n      }\n\n      #Disconnect .cls-3 {\n        fill: #ff7600;\n      }\n\n      #Disconnect .cls-4 {\n        fill: #f5f5f5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2719",
    "data-name": "Gruppe 2719",
    transform: "translate(0 3.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2663",
    "data-name": "Pfad 2663",
    className: "cls-1",
    d: "M11.945,7.234A10.618,10.618,0,1,1,1.327,17.852,10.63,10.63,0,0,1,11.945,7.234m0-1.327A11.945,11.945,0,1,0,23.89,17.852,11.945,11.945,0,0,0,11.945,5.907",
    transform: "translate(0 -5.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2664",
    "data-name": "Pfad 2664",
    className: "cls-1",
    d: "M14.616,12.326a8.446,8.446,0,0,0-6.575,3.147l.71.71a7.44,7.44,0,0,1,11.8.09l.709-.71a8.444,8.444,0,0,0-6.642-3.236",
    transform: "translate(-2.705 -8.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2665",
    "data-name": "Pfad 2665",
    className: "cls-1",
    d: "M16.024,18.192a4.568,4.568,0,0,0-3.8,2.032l.731.731a3.542,3.542,0,0,1,6.188.1l.735-.735a4.565,4.565,0,0,0-3.856-2.13",
    transform: "translate(-4.113 -10.039)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2666",
    "data-name": "Pfad 2666",
    className: "cls-1",
    d: "M15.32,15.259a6.5,6.5,0,0,0-5.187,2.589l.71.71a5.506,5.506,0,0,1,9.021.09l.71-.71a6.5,6.5,0,0,0-5.254-2.678",
    transform: "translate(-3.408 -9.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2667",
    "data-name": "Pfad 2667",
    className: "cls-1",
    d: "M19.3,27.026a2.655,2.655,0,1,1-5.309,0c0-1.483,2.654-5.278,2.654-5.278s2.654,3.8,2.654,5.278m-1.473-.874a.69.69,0,1,0,.682.69.685.685,0,0,0-.682-.69",
    transform: "translate(-4.707 -11.236)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2716",
    "data-name": "Gruppe 2716",
    transform: "translate(11.427 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2718",
    "data-name": "Gruppe 2718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2669",
    "data-name": "Pfad 2669",
    className: "cls-2",
    d: "M28.328,12.381a6.694,6.694,0,0,1-1.838,1.195,6.64,6.64,0,0,1-9.251-5.561c-.013-.173-.02-.352-.02-.531a6.393,6.393,0,0,1,.212-1.646,8.491,8.491,0,0,1,2.442-.358,8.641,8.641,0,0,1,8.455,6.9",
    transform: "translate(-17.219 -1.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2670",
    "data-name": "Pfad 2670",
    className: "cls-3",
    d: "M24.364,0A5.641,5.641,0,1,0,30,5.641,5.647,5.647,0,0,0,24.364,0",
    transform: "translate(-17.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2671",
    "data-name": "Pfad 2671",
    className: "cls-4",
    d: "M26.226,7.155l-.409-2.836V2.473h1.625V4.319l-.372,2.836Zm-.382.707h1.6v1.6h-1.6Z",
    transform: "translate(-20.111 -0.832)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorNoData);
export default __webpack_public_path__ + "static/media/sensor-no-data.9d24a9a0745b41e587c27a2e169ec262.svg";
export { ForwardRef as ReactComponent };